import { Box, Divider, makeStyles } from '@material-ui/core';
import React from 'react';
import EditMultiCountdown from 'src/components/editor/EditMultiCountdown';
import EditCountdown from 'src/components/editor/EditCountdown';
import EditMultiText from 'src/components/editor/EditMultiText';
import EditText from 'src/components/editor/EditTextRegurcy';
import EditBgImage from 'src/components/editor/EditBgImageRegurcy';
import EditMultiBgImage from 'src/components/editor/EditMultiBgImage';
import EditRadius from 'src/components/editor/EditRadiusRegurcy';
import EditDeeplink from 'src/components/editor/EditDeeplinkRegurcy';
import EditMultiDeeplink from 'src/components/editor/EditMultiDeeplink';
import EditBg from 'src/components/editor/EditBgRegurcy';
import EditMultiBg from 'src/components/editor/EditMultiBg';
import { useSelector, RootState } from 'src/store';
const useStyles = makeStyles({
  divider: {
    height: '2px'
  }
});
const Text: any = ({ datas }: any) => {
  const classes = useStyles();
  let btnType = useSelector((state: RootState) => state.buttons.btnType);
  if (datas?.convert && btnType === 'single') {
    datas.deeplinkType = ['image_button'];
  } else if (datas?.convert && btnType === 'double') {
    datas.deeplinkType = ['image_left_button', 'image_right_button'];
  }

  return (
    <Box>
      {datas?.bgType?.map((type: any, idx: number) => {
        return (
          <div key={idx}>
            <EditBg type={type} />
            {datas?.radiusType && datas?.radiusType?.indexOf(type) !== -1 && (
              <EditRadius
                menuTitle={type.toUpperCase()}
                type={type}
                max={datas?.radiusMax?.[datas?.radiusType?.indexOf(type)]}
              />
            )}
            <Divider className={classes.divider} />
          </div>
        );
      })}

      {datas?.multiBgType?.map((type: any, idx: number) => {
        return (
          <div key={idx}>
            <EditMultiBg
              menuTitle={type
                .split('_')
                .join(' ')
                .toUpperCase()
                .replace('MULTI ', '')}
              type={type}
            />
            {datas?.radiusType && datas?.radiusType?.indexOf(type) !== -1 && (
              <EditRadius
                menuTitle={type
                  .split('_')
                  .join(' ')
                  .toUpperCase()
                  .replace('MULTI ', '')}
                type={type}
                max={datas?.radiusMax?.[datas?.radiusType?.indexOf(type)]}
              />
            )}
            <Divider className={classes.divider} />
          </div>
        );
      })}

      {datas?.imageType?.map((type: any, idx: number) => {
        return (
          <div key={idx}>
            <EditBgImage menuTitle="IMAGE BACKGROUND" type={type} />
            {datas?.radiusType && datas?.radiusType?.indexOf(type) !== -1 && (
              <EditRadius
                menuTitle="IMAGE"
                type={type}
                max={datas?.radiusMax?.[datas?.radiusType?.indexOf(type)]}
              />
            )}
            <Divider className={classes.divider} />
          </div>
        );
      })}

      {datas?.multiImageType?.map((type: any, idx: number) => {
        return (
          <div key={idx}>
            <EditMultiBgImage menuTitle="IMAGE BACKGROUND" type={type} />
            {datas?.radiusType && datas?.radiusType?.indexOf(type) !== -1 && (
              <EditRadius
                menuTitle="IMAGE"
                type={type}
                max={datas?.radiusMax?.[datas?.radiusType?.indexOf(type)]}
              />
            )}
            <Divider className={classes.divider} />
          </div>
        );
      })}

      {datas?.deeplinkType?.map((type: any, idx: number) => {
        return (
          <div key={idx}>
            <EditDeeplink
              menuTitle={type
                .split('_')
                .join(' ')
                .toUpperCase()}
              type={type}
            />
            <Divider className={classes.divider} />
          </div>
        );
      })}

      {datas?.multiDeeplinkType?.map((type: any, idx: number) => {
        return (
          <div key={idx}>
            <EditMultiDeeplink
              menuTitle={type
                .split('_')
                .join(' ')
                .toUpperCase()}
              type={type}
            />
            <Divider className={classes.divider} />
          </div>
        );
      })}

      {datas?.textType?.map((type: any, idx: number) => {
        return (
          <div key={idx} style={{ position: 'relative' }}>
            <EditText
              menuTitle={type
                .split('_')
                .join(' ')
                .toUpperCase()}
              type={type}
            />

            <Divider className={classes.divider} />
          </div>
        );
      })}

      {datas?.multiTextType?.map((type: any, idx: number) => {
        return (
          <div key={idx} style={{ position: 'relative' }}>
            <EditMultiText
              menuTitle={type
                .split('_')
                .join(' ')
                .toUpperCase()
                .replace('MULTI ', '')}
              type={type}
            />

            <Divider className={classes.divider} />
          </div>
        );
      })}
      {datas?.countdownType?.map((type: any, idx: number) => {
        return (
          <div key={idx}>
            <EditCountdown
              menuTitle={type
                .split('_')
                .join(' ')
                .toUpperCase()}
              type={type}
            />
            <Divider className={classes.divider} />
          </div>
        );
      })}
      {datas?.multiCountdownType?.map((type: any, idx: number) => {
        return (
          <div key={idx}>
            <EditMultiCountdown
              menuTitle={type
                .split('_')
                .join(' ')
                .toUpperCase()
                .replace('MULTI ', '')}
              type={type}
            />
            <Divider className={classes.divider} />
          </div>
        );
      })}
    </Box>
  );
};

export default Text;
